"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EAuthorEntity = exports.ItemSource = exports.OfferQualityLevel = exports.IssueActionType = exports.IssueType = exports.OfferCatalogStatus = exports.ItemIdentifierType = exports.ItemUnity = exports.OfferStatus = exports.ItemCondition = exports.CategoryStatus = exports.ItemAttributeValueType = void 0;
var ItemAttributeValueType;
(function (ItemAttributeValueType) {
    ItemAttributeValueType["BooleanType"] = "BOOLEAN";
    ItemAttributeValueType["ListType"] = "LIST";
    ItemAttributeValueType["NumberUnitType"] = "NUMBER_UNIT";
    ItemAttributeValueType["DecimalUnitType"] = "DECIMAL_UNIT";
    ItemAttributeValueType["NumberType"] = "NUMBER";
    ItemAttributeValueType["DecimalType"] = "DECIMAL";
    ItemAttributeValueType["StringType"] = "STRING";
    ItemAttributeValueType["GridId"] = "GRID_ID";
    ItemAttributeValueType["GridRowId"] = "GRID_ROW_ID";
})(ItemAttributeValueType || (exports.ItemAttributeValueType = ItemAttributeValueType = {}));
var CategoryStatus;
(function (CategoryStatus) {
    CategoryStatus["Active"] = "ACTIVE";
    CategoryStatus["Inactive"] = "INACTIVE";
})(CategoryStatus || (exports.CategoryStatus = CategoryStatus = {}));
var ItemCondition;
(function (ItemCondition) {
    ItemCondition["New"] = "NEW";
    ItemCondition["UsedLikeNew"] = "USED_LIKE_NEW";
    ItemCondition["UsedVeryGood"] = "USED_VERY_GOOD";
    ItemCondition["UsedGood"] = "USED_GOOD";
    ItemCondition["UsedAcceptable"] = "USED_ACCEPTABLE";
    ItemCondition["Refurbished"] = "REFURBISHED";
})(ItemCondition || (exports.ItemCondition = ItemCondition = {}));
var OfferStatus;
(function (OfferStatus) {
    OfferStatus["New"] = "NEW";
    OfferStatus["Publishing"] = "PUBLISHING";
    OfferStatus["Unpublishing"] = "UNPUBLISHING";
    OfferStatus["Published"] = "PUBLISHED";
    OfferStatus["Unpublished"] = "UNPUBLISHED";
    OfferStatus["RequestApproval"] = "REQUEST_APPROVAL";
    OfferStatus["Error"] = "ERROR";
    OfferStatus["Archived"] = "ARCHIVED";
})(OfferStatus || (exports.OfferStatus = OfferStatus = {}));
var ItemUnity;
(function (ItemUnity) {
    ItemUnity["Unit"] = "UNIT";
    ItemUnity["Package"] = "PACKAGE";
    ItemUnity["SquareMeter"] = "SQUARE_METER";
    ItemUnity["SquareCentimeter"] = "SQUARE_CENTIMETER";
    ItemUnity["Centimeter"] = "CENTIMETER";
    ItemUnity["Meter"] = "METER";
    ItemUnity["Kilometer"] = "KILOMETER";
    ItemUnity["Box"] = "BOX";
    ItemUnity["Dozen"] = "DOZEN";
    ItemUnity["Hundred"] = "HUNDRED";
    ItemUnity["Gross"] = "GROSS";
    ItemUnity["Pair"] = "PAIR";
    ItemUnity["Piece"] = "PIECE";
    ItemUnity["Roll"] = "ROLL";
    ItemUnity["Kilogram"] = "KILOGRAM";
    ItemUnity["Gram"] = "GRAM";
    ItemUnity["Arroba"] = "ARROBA";
    ItemUnity["Liter"] = "LITER";
    ItemUnity["Milliliter"] = "MILLILITER";
    ItemUnity["CubicMeter"] = "CUBIC_METER";
    ItemUnity["PerHour"] = "PER_HOUR";
    ItemUnity["PerDay"] = "PER_DAY";
})(ItemUnity || (exports.ItemUnity = ItemUnity = {}));
var ItemIdentifierType;
(function (ItemIdentifierType) {
    /**
     * Global Trade Item Number: this is a 14-digit number used primarily in Europe, in other parts of the world it is known as EAN-14.
     */
    ItemIdentifierType["GTIN"] = "GTIN";
    /**
     * European Article Number: this is a 8 or 13-digit number used primarily in Europe, in other parts of the world it is known as GTIN-13.
     */
    ItemIdentifierType["EAN"] = "EAN";
    /**
     * Pharmazentralnummer: this is a 8-digit number used in Germany for pharmaceuticals, remedies and other pharmacy products.
     */
    ItemIdentifierType["PZN"] = "PZN";
    /**
     * International Standard Book Number: this is a 10 or 13-digit number used primarily in books.
     */
    ItemIdentifierType["ISBN"] = "ISBN";
    /**
     * Universal Product Code: this is a 12-digit number used primarily in North America, in other parts of the world it is known as GTIN-12.
     */
    ItemIdentifierType["UPC"] = "UPC";
    /**
     * Amazon Standard Identification Number: this is a 10-character number used primarily in Amazon.
     */
    ItemIdentifierType["ASIN"] = "ASIN";
    /**
     * Price look-up code: this is a 10 or 13-digit number used to identify bulk produce (and related items such as nuts and herbs)..
     */
    ItemIdentifierType["PLU"] = "PLU";
    ItemIdentifierType["NotApply"] = "NOT_APPLY";
})(ItemIdentifierType || (exports.ItemIdentifierType = ItemIdentifierType = {}));
var OfferCatalogStatus;
(function (OfferCatalogStatus) {
    OfferCatalogStatus["Unavailable"] = "UNAVAILABLE";
    OfferCatalogStatus["Available"] = "AVAILABLE";
    OfferCatalogStatus["Mandatory"] = "MANDATORY";
    OfferCatalogStatus["Enabled"] = "ENABLED";
})(OfferCatalogStatus || (exports.OfferCatalogStatus = OfferCatalogStatus = {}));
var IssueType;
(function (IssueType) {
    IssueType["Info"] = "INFO";
    IssueType["Error"] = "ERROR";
    IssueType["Warning"] = "WARNING";
    IssueType["RequestApproval"] = "REQUEST_APPROVAL";
    IssueType["RequiredField"] = "REQUIRED_FIELD";
    IssueType["InvalidFieldValue"] = "INVALID_FIELD_VALUE";
})(IssueType || (exports.IssueType = IssueType = {}));
var IssueActionType;
(function (IssueActionType) {
    IssueActionType["OpenExternalUrl"] = "OPEN_EXTERNAL_URL";
    IssueActionType["OpenSupport"] = "OPEN_SUPPORT";
    IssueActionType["RetryPublish"] = "RETRY_PUBLISH";
    IssueActionType["OpenRelatedAttribute"] = "OPEN_RELATED_ATTRIBUTE";
    IssueActionType["Hidden"] = "HIDDEN";
})(IssueActionType || (exports.IssueActionType = IssueActionType = {}));
var OfferQualityLevel;
(function (OfferQualityLevel) {
    /**
     * range: 0 to 49 percent
     */
    OfferQualityLevel["Basic"] = "BASIC";
    /**
     * range: 50 to 79 percent
     */
    OfferQualityLevel["Normal"] = "NORMAL";
    /**
     * range: 80 to 98 percent
     */
    OfferQualityLevel["Good"] = "GOOD";
    /**
     * range: 99 to 100 percent
     */
    OfferQualityLevel["Excelent"] = "EXCELENT";
})(OfferQualityLevel || (exports.OfferQualityLevel = OfferQualityLevel = {}));
var ItemSource;
(function (ItemSource) {
    ItemSource["CatalogBased"] = "CATALOG_BASED";
    ItemSource["Cloned"] = "CLONED";
    ItemSource["Imported"] = "IMPORTED";
    ItemSource["ManuallyCreated"] = "MANUALLY_CREATED";
})(ItemSource || (exports.ItemSource = ItemSource = {}));
var EAuthorEntity;
(function (EAuthorEntity) {
    EAuthorEntity["Application"] = "APPLICATION";
    EAuthorEntity["ChannelAMZ"] = "CHANNEL_AMZ";
    EAuthorEntity["ChannelShopee"] = "CHANNEL_SHOPEE";
    EAuthorEntity["ChannelShopify"] = "CHANNEL_SHOPIFY";
    EAuthorEntity["ChannelML"] = "CHANNEL_ML";
    EAuthorEntity["User"] = "USER";
})(EAuthorEntity || (exports.EAuthorEntity = EAuthorEntity = {}));
//# sourceMappingURL=item.js.map